export let CommunicationChannel = /*#__PURE__*/function (CommunicationChannel) {
  CommunicationChannel["UNKNOWN_COMMUNICATION_CHANNEL"] = "UNKNOWN_COMMUNICATION_CHANNEL";
  CommunicationChannel["APP"] = "APP";
  CommunicationChannel["WHATSAPP"] = "WHATSAPP";
  CommunicationChannel["SMS"] = "SMS";
  CommunicationChannel["EMAIL"] = "EMAIL";
  CommunicationChannel["TELEGRAM"] = "TELEGRAM";
  CommunicationChannel["WEB"] = "WEB";
  CommunicationChannel["VOICE"] = "VOICE";
  CommunicationChannel["EXTERNAL_AGENT"] = "EXTERNAL_AGENT";
  CommunicationChannel["PHONE_CALL"] = "PHONE_CALL";
  return CommunicationChannel;
}({});
export let OnboardingState = /*#__PURE__*/function (OnboardingState) {
  OnboardingState["UNKNOWN_ONBOARDING_STATE"] = "UNKNOWN_ONBOARDING_STATE";
  OnboardingState["ONBOARDING_NOT_STARTED"] = "ONBOARDING_NOT_STARTED";
  OnboardingState["ONBOARDING_GREETED"] = "ONBOARDING_GREETED";
  OnboardingState["ONBOARDING_ENGAGED"] = "ONBOARDING_ENGAGED";
  OnboardingState["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
  return OnboardingState;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
//# sourceMappingURL=types.js.map